// extracted by mini-css-extract-plugin
export default {"root":"style_root__JCHwj","links":"style_links__7GAvD","link":"style_link__qK9mo","separator":"style_separator__ytdni","powered":"style_powered__niZVe"};